import React from 'react'
import { Choose11, Choose22 } from '../Reusable/Choose'

const Service = () => {
    return (
        <div className='lg:pt-[8%] bg-[#161616] pb-[8%] relative flex flex-col lg:px-[8%] px-[4%] gap-8'>
            <div className='flex flex-col w-full gap-8 mt-5 items-center justify-center'>
                <div className='lg:w-[56%] gap-4 w-full flex flex-col items-center justify-center'>
                    <p className='lg:text-[40px] text-[25px] text-white font-semibold '>Some Easy Way of Working</p>
                    <p className='text-[14px] text-[#ffffff] text-center'>Each product is crafted to optimize efficiency, enhance sustainability, and support fair trade practices across the globe."</p>
                </div>

                <div data-aos="zoom-in-down" className='w-full grid lg:grid-cols-3 gap-11 md:grid-cols-2 grid-cols-1'>
                <Choose11
                    img={"/Blockfarm/advance.svg"}
                    heading={"Equipment Procurement"}
                    paragraph={"Our dedicated team helps you navigate the complex process of acquiring your mining equipment while taking the headache from logistics and administration."}
                />
                <Choose22
                    img={"/Blockfarm/smart.svg"}
                    heading={"Secure Facilities"}
                    paragraph={"Our state-of-the-art mining hosting facilities are located in several locations around the world to ensure maximum uptime. Plus, your equipment will be in the good hands of."}
                />
                <Choose11
                    img={"/Blockfarm/set.svg"}
                    heading={"Financing"}
                    paragraph={"We designed our mining equipment financing to provide flexibility for our investors to reap maximum benefits."}
                />
            </div>
            </div>
        </div>
    )
}

export default Service